import { AccountingPeriodsQuery, YearEndCloseQuery } from '../../../../generated'

// Extract single element type from the array
export type AccountingPeriod = AccountingPeriodsQuery['accountingPeriods'][number]

// Extract YearEndClose type from generated query
export type YearEndClose = NonNullable<YearEndCloseQuery['yearEndClose']>

export interface CloseAccountingPeriodInput {
  fiscalYear: number
  month: number
  accountId?: string
  notes?: string
}

export interface UncloseAccountingPeriodInput {
  fiscalYear: number
  month: number
}

export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]

export const QUARTER_NAMES = ['Q1', 'Q2', 'Q3', 'Q4']

export function getMonthName(month: number): string {
  return MONTH_NAMES[month - 1] || ''
}

export function getQuarter(month: number): number {
  return Math.ceil(month / 3)
}

export function getQuarterName(month: number): string {
  return QUARTER_NAMES[getQuarter(month) - 1] || ''
}
